
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guides/toplists",
      function () {
        return require("private-next-pages/guides/toplists.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guides/toplists"])
      });
    }
  